import { MultiSelectSearcher } from "../Abstractions/MultiSearcher/MultiSearcher";
import { useContractorSearch } from "./searchContractor";
import { useAddressSearch } from "../Addresses/AddressSearch";

export function ContractorMultiSelect({ label, name, readonly, required = true }) {
  const { items, onSearchChange } = useContractorSearch({ });

  return (
    <div className="mb-2">
      <MultiSelectSearcher
        name={name}
        label={label}
        items={items}
        onSearchChange={onSearchChange}
        optionsObject={{ key: "id", value: "name" }}
        placeholder="Wyszukaj klienta po nazwie..."
        optionSave={x => x.id}
        required={required}
        saveWholeObject
        readonly={readonly}
      />
    </div>
  );
}

export function AddressMultiSelect({ label, name, readonly, required = true }) {
  const { items, onSearchChange } = useAddressSearch();

  return (
    <div className="mb-2">
      <MultiSelectSearcher
        name={name}
        label={label}
        items={items}
        onSearchChange={onSearchChange}
        optionsObject={{ key: "id", value: "name" }}
        placeholder="Wyszukaj adres po nazwie..."
        optionSave={x => x.id}
        required={required}
        saveWholeObject
        readonly={readonly}
      />
    </div>
  );
}